import React, { useState } from "react";
import { usePagination } from "../../../hooks/usePagination";
import ResultHandler from "../../../components/ResultHandler";
import PaginationHandler from "../../../components/PaginationHandler";
import TableHeaderHandler from "../../../components/TableHeaderHandler";
import { useTranslation } from "react-i18next";
import TableAction from "../../../components/TableAction";
import EmptyData from "../../../components/EmptyData";
import { Table, Thead, Tbody, Td, Tr, Th } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { PERMISSIONS } from "../../../api/permissions";
import moment from "moment";
import { Badge } from "reactstrap";
import { useParams } from "react-router-dom";
import { useResponse } from "../../../hooks/useResponse";
import DeleteModal from "../../../components/Common/DeleteModal";
import { deleteInsurance, getAllInsurances } from "../../../api/insurance";

export default function InsuranceTable() {
  const { t } = useTranslation();
  const { id: employeeId } = useParams();

  const {
    response,
    loading,
    error,
    setPage,
    page,
    setPerPage,
    totalPages,
    setPayload,
    setMeta,
  } = usePagination(
    getAllInsurances,
    employeeId ? { employee_id: employeeId } : null
  );

  // delete
  const [show, setShow] = useState(false);
  const [deletingInsurance, setDeletingInsurance] = useState(null);

  const { setData } = useResponse(deleteInsurance, () => {
    setShow(false);
    setDeletingInsurance(null);
    setPayload({ employee_id: employeeId, ref: true });
  });

  function onDeleteClick() {
    setData({ type: "delete", data: deletingInsurance });
  }

  function onCloseClick() {
    setShow(false);
  }

  return (
    <>
      <TableHeaderHandler
        permission={PERMISSIONS.INSURANCE_CREATE}
        addUrl={
          employeeId ? "/add-insurance/" + employeeId : "/add-insurance/noId"
        }
        setPage={setPage}
        setPerPage={setPerPage}
      ></TableHeaderHandler>

      <div className="table-rep-plugin">
        <div className="table-responsive">
          <Table className="table table-striped table-bordered">
            <Thead className="table-light table-nowrap">
              <Tr>
                {!employeeId && <Th>Employee</Th>}
                <Th>Type</Th>
                <Th>Number</Th>
                <Th>End Date</Th>
                <Th className="text-center">Active</Th>
                <Th style={{ width: "20%" }}>{t("tables.Action")}</Th>
              </Tr>
            </Thead>

            {response.data && !loading && (
              <Tbody>
                {response.data.insurances.map((row) => {
                  return (
                    <Tr key={row.id}>
                      {!employeeId && <Td>{row.employee.name}</Td>}
                      <Td>{row.insurance_type}</Td>
                      <Td>{row.insurance_number}</Td>
                      <Td>
                        {row.insurance_end_date
                          ? moment(row.insurance_end_date).format("DD MMM YYYY")
                          : "-"}
                      </Td>
                      <Td className="text-center">
                        <Badge
                          className="text-upercase"
                          color={row.insurance_active ? "success" : "danger"}
                        >
                          {row.insurance_active ? "YES" : "NO"}
                        </Badge>
                      </Td>
                      <Td>
                        <TableAction
                          hasEdit={true}
                          editPermission={PERMISSIONS.INSURANCE_EDIT}
                          hasDelete={true}
                          deletePermission={PERMISSIONS.INSURANCE_DELETE}
                          type="insurance"
                          id={row.id}
                          setShow={setShow}
                          setDeleteIntitiy={setDeletingInsurance}
                        />
                      </Td>
                    </Tr>
                  );
                })}
              </Tbody>
            )}
          </Table>

          {!loading && (
            <EmptyData
              empty={response.data && response.data.insurances.length === 0}
              msg="No Insurance Found."
            />
          )}

          <DeleteModal
            show={show}
            onDeleteClick={onDeleteClick}
            onCloseClick={onCloseClick}
          />

          {response.data && !loading && (
            <PaginationHandler
              page={page}
              setPage={setPage}
              totalPages={totalPages}
            />
          )}

          <ResultHandler error={error} loading={loading} />
        </div>
      </div>
    </>
  );
}
